import { useState } from 'react';
import { TextField } from '@mui/material';
import { Button } from '@mui/material';
import './Login.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import logoParana from '../../assets/ParanaMap_Oficial.png';
import API_URL from '../../config/api';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Login() {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const navigate = useNavigate();

	function logIn(event) {
		event.preventDefault();

		const payload = {
			username,
			password,
			deviceInfo: {
				userAgent: navigator.userAgent,
				screen: `${window.screen.width}x${window.screen.height}`,
				touch: 'ontouchstart' in window,
			},
		};

		axios
			.post(`${API_URL}/api/User/login`, payload)
			.then(response => {
				console.log(response.data)
				localStorage.setItem(
					'company',
					btoa(JSON.stringify(response.data.company))
				);
				localStorage.setItem(
					'role',
					btoa(JSON.stringify(response.data.role))
				);
				localStorage.setItem(
					'token',
					btoa(JSON.stringify(response.data.token))
				);
				localStorage.setItem(
					'username',
					btoa(JSON.stringify(response.data.username))
				);
				localStorage.setItem(
					'name',
					btoa(JSON.stringify(response.data.name))
				);
				localStorage.setItem(
					'surname',
					btoa(JSON.stringify(response.data.surname))
				);
				navigate('/Home');
			})
			.catch(() => {
				toast.error('Usuário ou senha inválidos.');
			});
	}

	return (
		<div className="login-container">
			<ToastContainer position="top-right" autoClose={3000} />

			<div className="login-wrapper">
				<img src={logoParana} alt="Logo" className="login-logo" />
				<form className="login-form" onSubmit={logIn}>
					<h1 className="login-title">Login</h1>
					<TextField
						fullWidth
						label="Login"
						size="small"
						className="login-input"
						onChange={e => setUsername(e.target.value)}
					/>
					<div className="login-input-container">
						<TextField
							fullWidth
							label="Senha"
							size="small"
							type="password"
							className="login-input"
							onChange={e => setPassword(e.target.value)}
						/>
						<div className="forgot-password-container">
							<span
								className="forgot-password-link"
								onClick={() => navigate('/reset-password')}
							>
								Esqueceu a senha?
							</span>
						</div>
					</div>

					<Button
						variant="contained"
						type="submit"
						className="login-button"
					>
						Entrar
					</Button>
				</form>
			</div>
		</div>
	);
}
